import type { PlanUsage } from '@recruitai/shared';

interface PlanUsageBarProps {
  data: PlanUsage;
}

function UsageRow({ label, current, max, percentage }: { label: string; current: number; max: number; percentage: number }) {
  const isAlert = percentage >= 80;
  const barColor = isAlert ? 'bg-red-500' : 'bg-blue-500';
  const textColor = isAlert ? 'text-red-600' : 'text-gray-600';

  return (
    <div className="mb-4">
      <div className="flex justify-between text-sm mb-1">
        <span className="font-medium text-gray-700">{label}</span>
        <span className={textColor}>
          {current} / {max} ({Math.round(percentage)}%)
        </span>
      </div>
      <div className="w-full bg-gray-200 rounded-full h-3">
        <div
          className={`${barColor} h-3 rounded-full transition-all`}
          style={{ width: `${Math.min(percentage, 100)}%` }}
        />
      </div>
      {isAlert && (
        <p className="text-xs text-red-600 mt-1">
          ⚠ Uso acima de 80% — considere fazer upgrade do plano
        </p>
      )}
    </div>
  );
}

export function PlanUsageBar({ data }: PlanUsageBarProps) {
  return (
    <div className="bg-white rounded-lg border p-4">
      <h3 className="text-sm font-medium text-gray-700 mb-3">Uso do Plano</h3>
      <UsageRow label="Vagas" current={data.jobsCreated} max={data.maxJobs} percentage={data.jobsPercentage} />
      <UsageRow label="Candidatos/mês" current={data.candidatesProcessed} max={data.maxCandidatesPerMonth} percentage={data.candidatesPercentage} />
    </div>
  );
}
